import { useForm } from "react-hook-form";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { TITULO_GRUPO_REG } from "../../../utils/constantes";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { FormInput } from "../../../components/molecules/FormInput";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormSelect } from "../../../components/atoms/FormSelect";
import { getAllIdiomas } from "../../../services/idioma.service";
import { getAllTurnos } from "../../../services/turno.service";
import { getAllModalidades } from "../../../services/modalidad.service";
import { getAllHorarios } from "../../../services/horario.service";
import { getAllDocentesByIdIdioma } from "../../../services/docente.service";
import { getAllModulosByIdIdioma } from "../../../services/modulo.service";
import { crearGrupo } from "../../../services/grupo.service";
import { crearHorarioGrupo } from "../../../services/horarioGrupo";
import { NuevoHorarioFormCard } from "../../../modules/grupo/NuevoHorarioFormCard";

export const RegistrarGrupoPage = () => {
  const [estaCargando, setEstaCargando] = useState(false);
  const [idiomas, setIdiomas] = useState([]);
  const [docentes, setDocentes] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [turnos, setTurnos] = useState([]);
  const [modalidades, setModalidades] = useState([]);
  const [horarios, setHorarios] = useState([]);

  const navigate = useNavigate();
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    obtenerIdiomas();
    obtenerTurnos();
    obtenerModalidades();
    obtenerHorarios();
  }, []);

  const obtenerIdiomas = async () => {
    await getAllIdiomas()
      .then((idiomas) => {
        setIdiomas(
          idiomas?.map((idioma) => ({
            value: idioma?.idIdioma,
            label: idioma?.nombre,
          }))
        );
      })
      .catch((err) => console.log(err));
  };

  const obtenerTurnos = async () => {
    await getAllTurnos()
      .then((turnos) => {
        setTurnos(
          turnos?.map((turno) => ({
            value: turno?.idTurno,
            label: turno?.nombre,
          }))
        );
      })
      .catch((err) => console.log(err));
  };

  const obtenerModalidades = async () => {
    await getAllModalidades()
      .then((modalidades) => {
        setModalidades(
          modalidades?.map((modalidad) => ({
            value: modalidad?.idModalidad,
            label: modalidad?.nombre,
          }))
        );
      })
      .catch((err) => console.log(err));
  };

  const obtenerHorarios = async () => {
    await getAllHorarios()
      .then((horarios) => {
        setHorarios(
          horarios?.map((horario) => ({
            value: horario?.idHorario,
            label: `${horario?.dia?.nombre} - ${horario?.horaInicio} - ${horario?.horaFin}`,
          }))
        );
      })
      .catch((err) => console.log(err));
  };

  const handleGetDocentesYModulosByIdIdioma = async (data) => {
    await getAllDocentesByIdIdioma(data?.value)
      .then((docentes) =>
        setDocentes(
          docentes?.map((docente) => ({
            value: docente?.idDocente,
            label: `${docente?.nombre} ${docente?.apellido}`,
          }))
        )
      )
      .catch((err) => console.log(err));
    await getAllModulosByIdIdioma(data?.value)
      .then((modulos) =>
        setModulos(
          modulos?.map((modulo) => ({
            value: modulo?.idModulo,
            label: `${modulo?.nombre} - ${modulo?.sigla}`,
          }))
        )
      )
      .catch((err) => console.log(err));
  };

  const submit = async (data) => {
    setEstaCargando(true);

    const dataGrupo = {
      nombre: data?.nombre,
      nombreAntGrupo: data?.nombreAntGrupo || null,
      cupos: parseInt(data?.cupos, 10),
      cuentaZoom: data?.cuentaZoom || null,
      contrasenaZoom: data?.contrasenaZoom || null,
      nombreAuxiliar: data?.nombreAuxiliar || null,
      celularAuxiliar: data?.celularAuxiliar || null,
      fechaInicio: data?.fechaInicio,
      fechaFin: data?.fechaFin,
      idTurno: data.idTurno?.value,
      idDocente: data.idDocente?.value,
      idModulo: data.idModulo?.value,
      idModalidad: data.idModalidad?.value,
      dias: [], // Campo requerido por el servidor
    };
    // Validar campos requeridos antes de enviar
    if (!dataGrupo.nombre || !dataGrupo.idTurno || !dataGrupo.idDocente || !dataGrupo.idModulo || !dataGrupo.idModalidad) {
      showErrorAlert({ text: 'Por favor complete todos los campos obligatorios' });
      setEstaCargando(false);
      return;
    }

    try {
      const nuevoGrupoCreado = await crearGrupo(dataGrupo);
      const promesasHorariosGrupo = data.horarioAulas.map(
        async (horarioAula) => {
          const dataHorarioGrupo = {
            nroAula: horarioAula.nroAula || "",
            idHorario: horarioAula.idHorario?.value || "",
            idGrupo: nuevoGrupoCreado?.idGrupo,
          };
          return await crearHorarioGrupo(dataHorarioGrupo);
        }
      );
      await Promise.all(promesasHorariosGrupo);
      showAlert({
        callback: () => {
          navigate("/grupos");
        },
      });
    } catch (err) {
      console.error('❌ Error completo:', err);
      console.error('❌ Respuesta del servidor:', err.response);
      console.error('🔍 Mensaje de error:', JSON.stringify(err.response?.data, null, 2));
      
      const errorMessage = err.response?.data?.message || JSON.stringify(err.response?.data) || 'Error al crear el grupo';
      showErrorAlert({ text: errorMessage });
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate titulo={TITULO_GRUPO_REG}>
      <FormHook handleSubmit={handleSubmit} submit={submit}>
        <FormDiv className="md:flex flex-wrap">
          <FormInput
            id="nombre"
            label="Nombre"
            type="text"
            placeholder="Nombre o sigla"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: {
                value: 50,
                message: "Súpero la cantidad máxima 50 caracteres",
              },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.nombre}
            className="md:w-1/2 md:pr-2"
          />
          
          {/* Nuevo campo para nombre anterior del grupo */}
          <FormInput
            id="nombreAntGrupo"
            label="Nombre anterior del grupo (opcional)"
            type="text"
            placeholder="Nombre anterior si hubo cambio"
            register={register}
            validation={{
              maxLength: {
                value: 100,
                message: "Súpero la cantidad máxima 100 caracteres",
              },
            }}
            error={errors.nombreAntGrupo}
            className="md:w-1/2 md:pl-2"
          />

          <FormInput
            id="cupos"
            label="Cupos"
            type="number"
            placeholder="Cupos disponibles"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
            }}
            error={errors.cupos}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="cuentaZoom"
            label="Link de zoom"
            type="text"
            placeholder="Link de zoom"
            register={register}
            validation={{
              maxLength: {
                value: 255,
                message: "Súpero la cantidad máxima 255 caracteres",
              },
            }}
            error={errors.cuentaZoom}
            className="md:w-1/2 md:pl-2"
          />
          <FormInput
            id="contrasenaZoom"
            label="Contraseña de zoom"
            type="text"
            placeholder="Contraseña de zoom"
            register={register}
            validation={{
              maxLength: {
                value: 255,
                message: "Súpero la cantidad máxima 255 caracteres",
              },
              minLength: { value: 2, message: "Mínimo 2 caracteres" },
            }}
            error={errors.contrasenaZoom}
            className="md:w-1/2 md:pl-2"
          />
          <FormInput
            id="nombreAuxiliar"
            label="Nombre de auxiliar"
            type="text"
            placeholder="Nombre completo"
            register={register}
            validation={{
              maxLength: {
                value: 60,
                message: "Supero la cantidad máxima 60 caracteres",
              },
              minLength: { value: 2, message: "Mínimo 2 caracter" },
            }}
            error={errors.nombreAuxiliar}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="celularAuxiliar"
            label="Número telefono de auxiliar"
            type="text"
            placeholder="Número telefono"
            register={register}
            validation={{
              maxLength: {
                value: 15,
                message: "Súpero la cantidad máxima 15 caracteres",
              },
              minLength: { value: 6, message: "Mínimo 6 caracter" },
            }}
            error={errors.celularAuxiliar}
            className="md:w-1/2 md:pl-2"
          />
          <FormInput
            id="fechaInicio"
            label="Fecha de inicio"
            type="date"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
            }}
            error={errors.fechaInicio}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="fechaFin"
            label="Fecha de fin"
            type="date"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
            }}
            error={errors.fechaFin}
            className="md:w-1/2 md:pl-2"
          />
        </FormDiv>
        <FormDiv className="md:flex">
          <FormSelect
            name="idiomas"
            label="Idioma"
            control={control}
            options={idiomas}
            validation={{ required: "Campo requerido" }}
            placeholder="Selecciona un idioma"
            handleChange={handleGetDocentesYModulosByIdIdioma}
            error={errors.idiomas}
            className="md:w-1/2 mb-4 md:pr-2"
          />
          <FormSelect
            name="idDocente"
            label="Docente"
            control={control}
            options={docentes}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un docente"
            error={errors.idDocente}
            className="md:w-1/2 md:pl-2"
          />
        </FormDiv>
        <FormDiv className="md:flex">
          <FormSelect
            name="idModulo"
            label="Módulo"
            control={control}
            options={modulos}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un módulo"
            error={errors.idModulo}
            className="md:w-1/2 md:pr-2"
          />
          <FormSelect
            name="idTurno"
            label="Turno"
            control={control}
            options={turnos}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione una turno"
            error={errors.idTurno}
            className="md:w-1/2 md:px-2"
          />
          <FormSelect
            name="idModalidad"
            label="Modalidad"
            control={control}
            options={modalidades}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione una modalidad"
            error={errors.idModalidad}
            className="md:w-1/2 md:pl-2"
          />
        </FormDiv>
        <NuevoHorarioFormCard
          control={control}
          register={register}
          horarios={horarios}
          errors={errors}
        />
        <SubmitButton estaCargando={estaCargando} />
      </FormHook>
    </ContenedorPageTemplate>
  );
};